<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
@if (isScreenSmall) {
    <fuse-vertical-navigation
        class="dark bg-gray-900 print:hidden"
        [mode]="'over'"
        [name]="'mainNavigation'"
        [navigation]="navigation.default"
        [opened]="false"
    >
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            <div class="flex h-20 items-center px-8 pt-6">
                <img
                    class="w-14"
                    src="images/logo/dp_logo.png"
                    alt="District Printing"
                />
            </div>
        </ng-container>
    </fuse-vertical-navigation>
}

<!-- Wrapper — dark mode uses the same deep slate as the orders workspace ambient -->
<div
    class="layout-page-shell relative flex w-full min-w-0 flex-auto flex-col items-center bg-gray-200 dark:bg-slate-950"
>
    <div class="layout-page-ambient" aria-hidden="true">
        <div class="layout-page-ambient__wash"></div>
        <workspace-particles
            [density]="0.55"
            [dotSize]="3"
            color="#94a3b8"
            [maxSpeed]="11"
            [minAlpha]="0.10"
            [maxAlpha]="0.45"
        ></workspace-particles>
    </div>
    <div class="layout-page-content relative z-[1] flex w-full min-w-0 flex-auto flex-col items-center min-h-0">
  <mat-drawer-container class="flex-auto w-full min-w-0"  [hasBackdrop]="false">

        <!-- Drawer content -->
        <mat-drawer-content class="flex flex-col">
    <!-- Header — outer band matches workspace (no primary-700 blue in dark) -->
    <div
        class="relative z-49 flex w-full justify-center overflow-hidden bg-gray-100 dark:bg-slate-950 print:hidden"
    >
        <div
            class="w-full max-w-360 overflow-hidden border-b border-gray-200 bg-white sm:m-8 sm:mb-0 sm:rounded-t-xl sm:py-3 sm:shadow-2xl md:mx-8 md:mt-12 md:pb-3 md:pt-4 dark:border-slate-800/80 dark:bg-slate-950"
        >
            <!-- Top bar -->
            <div
                class="layout-topbar-unified relative flex h-16 flex-0 flex-auto items-center px-4 md:px-6 lg:pr-3"
            >
                <!-- Logo -->
                @if (!isScreenSmall) {
                    <div class="mx-2 flex items-center">
                        <img
                            class="w-12"
                            src="images/logo/dp_logo.png"
                            alt="District Printing"
                        />
                    </div>
                }
                <!-- Navigation toggle button -->
                @if (isScreenSmall) {
                    <button
                        mat-icon-button
                        (click)="toggleNavigation('mainNavigation')"
                    >
                        <mat-icon
                            [svgIcon]="'heroicons_outline:bars-3'"
                        ></mat-icon>
                    </button>
                }
                <!-- Components -->
                <div
                    class="ml-auto flex items-center space-x-1 pl-2 sm:space-x-2"
                >
                    <button mat-icon-button (click)="openAddUserDrawer()" [matTooltip]="'Add new user'">
                        <mat-icon [svgIcon]="'heroicons_outline:user-plus'"></mat-icon>
                    </button>
                    <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
                    <!-- <search [appearance]="'bar'"></search>
                    <shortcuts></shortcuts> -->
                    <messages></messages>
                    <timeline-activities></timeline-activities>
                    <updates-required></updates-required>
                    <!-- <notifications></notifications> -->

                    <button
                        class="lg:hidden"
                        mat-icon-button
                        (click)="quickChat.toggle()"
                    >
                        <mat-icon
                            [svgIcon]="'heroicons_outline:chat-bubble-left-right'"
                        ></mat-icon>
                    </button>
                    <user></user>
                </div>
            </div>
            <div class="flex flex-auto flex-col">
                @if (true) {
                    <router-outlet></router-outlet>
                }
            </div>
 
         

        <mat-drawer #addUserDrawer class="w-full md:w-160" [mode]="'over'" [position]="'start'">
            <div class="p-8">
                <div class="flex items-center justify-between">
                    <h2 class="text-2xl font-semibold">New Customer</h2>
                    <button mat-icon-button (click)="addUserDrawer.close()">
                        <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                    </button>
                </div>
                @defer (on timer(1s)) {
                    <quick-add-user [customerMode]="true" (closeDrawer)="addUserDrawer.close()"></quick-add-user>
                }
            </div>
        </mat-drawer>
  
            <!-- Bottom bar -->
            @if (!isScreenSmall) {
                <div
                    class="relative flex h-16 flex-0 flex-auto items-center border-t border-gray-100 bg-gray-50 px-4 dark:border-slate-800/60 dark:bg-slate-950"
                >
                    <fuse-horizontal-navigation
                        [name]="'mainNavigation'"
                        [navigation]="navigation.horizontal"
                    ></fuse-horizontal-navigation>
                </div>
            }
        </div>
    </div>

    <!-- Content -->
    <div class="flex w-full flex-auto flex-col justify-center sm:px-8 lg:pr-[var(--quick-chat-rail-width)]">
        <div
            class="bg-default flex w-full flex-auto flex-col sm:max-w-360 sm:overflow-hidden sm:shadow-xl dark:bg-slate-950"
        >
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                 Otherwise, layout changes won't be registered and the view won't be updated! -->
            @if (true) {
                <router-outlet></router-outlet>
            }
        </div>

        <!-- Footer -->
        <div class="relative z-49 flex w-full justify-center print:hidden">
            <div
                class="bg-card flex h-14 w-full max-w-360 items-center border-t border-gray-200 px-6 dark:border-slate-800/80 dark:bg-slate-950 sm:h-20 sm:shadow-xl md:px-8"
            >
                <span class="text-secondary font-medium"
                    >District Printing &copy; {{ currentYear }}</span
                >
            </div>
        </div>
    </div>

        </mat-drawer-content>

    </mat-drawer-container>

    </div>
</div>
<quick-chat #quickChat="quickChat"></quick-chat>